import { action, computed } from 'mobx';
import { Watchlists } from '../models/configuration/Watchlists';
import { BaseStore } from '.';
import { GlobalStorageConfigSource } from '../models/configuration/global/GlobalStorageConfigSource';
import { helpers, models } from '@kurtosys/ksys-app-template/dist';
import { Stores } from '../models/Stores';
import { GlobalWatchlistConfig } from '../models/configuration/global/GlobalWatchlistConfig';

export class WatchlistStore extends BaseStore {
    isInitialized: boolean = false;
    watchlists: Watchlists | undefined;
    upsertTimeout;
    storageHelper: helpers.StorageHelper;
    storageKey = 'watchlists';

    constructor(stores: Stores) {
        super(stores);
    }

    @computed
    get watchlistConfig(): GlobalWatchlistConfig {
        return (
            this.stores.data &&
            this.stores.data.config &&
            this.stores.data.config.globalWatchlistConfig
        );
    }

    @action
    initialize = async (): Promise<void> => {
        if (!this.isInitialized) {
            const userWatchlistConfig = this.watchlistConfig;
            let storageType: models.helpers.StorageHelper.TStorageType;

            if (userWatchlistConfig) {
                switch (userWatchlistConfig.source) {
                    case GlobalStorageConfigSource.localStorage:
                        storageType = 'LOCAL';
                        break;
                    case GlobalStorageConfigSource.userConfiguration:
                        storageType = 'DB';
                        break;
                    case GlobalStorageConfigSource.sessionStorage:
                        storageType = 'SESSION';
                        break;
                }
                const storageHelperOptions: models.helpers.StorageHelper.IStorageHelperConfigurationOptions = {
                    type: storageType,
                    obfuscated: userWatchlistConfig.obfuscateValuesStored,
                    allowMultiple: userWatchlistConfig.allowMultiple,
                    getUserConfiguration: this.stores.data.services
                        .getUserConfiguration,
                    setUserConfiguration: this.stores.data.services
                        .setUserConfiguration,
                };

                this.storageHelper = new helpers.StorageHelper(
                    storageHelperOptions
                );
            }

            await this.getWatchlists();
            this.isInitialized = true;
        }
    };

    @action
    getWatchlist = (key: string): Array<string> => {
        return (this.watchlists && this.watchlists[key]) || [];
    };

    @action
    async getWatchlists() {
        if (this.storageHelper) {
            const response = (await this.storageHelper.getStorageValues(
                this.storageKey
            )) as Record<string, Array<string>>;

            this.watchlists = response || {};
        } else {
            console.warn(
                'Storage Helper not initialized, please check global user watchlist configuration'
            );
        }
    }

    @action
    setWatchlist = (key: string, value: Array<string>) => {
        this.watchlists[key] = value;
        this.setWatchlists();
    };

    @action
    async setWatchlists() {
        if (this.storageHelper) {
            await this.storageHelper.setStorageValues(
                this.storageKey,
                this.watchlists
            );
        } else {
            console.warn(
                'Storage Helper not initialized, please check global user watchlist configuration'
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/WatchlistStore.ts